export default [
  {
    path: 'organizations',
    name: 'organizations',
    component: () => import('@/views/pages/organization/Organization.vue'),
    meta: {
      pageTitle: 'Organizations',
      breadcrumb: [
        {
          text: 'Organizations',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
